import { toast } from 'aha-components';
import { getAhaBridge, hasNativeAhaBridge } from '@/app/bridge/ahaBridge';
import { isNativeAppRuntime } from '@/biz/tool';

const getCurrentBrowserUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('from');
  return url.toString();
};

const openCurrentPageInExternalBrowser = async () => {
  const url = getCurrentBrowserUrl();
  if (isNativeAppRuntime() && hasNativeAhaBridge()) {
    await getAhaBridge().auth.openExternalBrowser({ url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
};

const shouldUseBrowserFallback = async () => {
  if (!isNativeAppRuntime()) return false;
  if (!hasNativeAhaBridge()) return true;

  try {
    const capabilities = await getAhaBridge().auth.getCapabilities();
    return capabilities.socialAccountBindingCallback !== true;
  } catch (error) {
    console.error('[SocialBinding] failed to read native capabilities', error);
    return true;
  }
};

const showBrowserFallbackToast = () => {
  toast({
    message:
      'Account binding is not supported in the app yet. Please bind in your browser.',
    type: 'info',
    position: 'top-right',
    duration: 8000,
    showClose: true,
    action: (
      <button
        type="button"
        className="rounded-md bg-white px-3 py-1.5 text-sm font-medium text-[#1447E6]"
        onClick={(event) => {
          event.stopPropagation();
          void openCurrentPageInExternalBrowser();
        }}
      >
        Open in browser
      </button>
    )
  });
};

export const showSocialBindingBrowserFallbackIfNeeded = async () => {
  if (!(await shouldUseBrowserFallback())) return false;
  showBrowserFallbackToast();
  return true;
};
